import { useRef, useState } from 'react';

interface IProps {
    intervalDuration: number;
    onFinishCountdown: () => void
}

export const useCountdownTimer = ({ intervalDuration, onFinishCountdown }: IProps) => {
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  const timerId = useRef<any>(null);
  const loadTimeStamp = useRef<any>(null);
  const didFinishCounting = useRef<any>(false);

  function startTimer(timestamp?: any) {
    /** Reset */
    timestamp = timestamp || Date.now();
    loadTimeStamp.current = timestamp!!;
    didFinishCounting.current = false;
    const initialElapsedTimeInSeconds = (Date.now() - loadTimeStamp.current) / 1000;
    setTimeLeft(Number((intervalDuration - initialElapsedTimeInSeconds).toFixed(0)));

    timerId.current = setInterval(() => {
      if (didFinishCounting.current) {
        return;
      }
      // @ts-ignore
      const elapsedTimeInSeconds = (Date.now() - loadTimeStamp.current) / 1000;
      console.log(`elapsedTimeInSeconds - ${elapsedTimeInSeconds} , ${intervalDuration} , ${timestamp}`);
      setTimeLeft(Number((intervalDuration - elapsedTimeInSeconds).toFixed(0)));

      if (Math.max(intervalDuration - elapsedTimeInSeconds, 0) === 0) {
        onFinishCountdown();
        setTimeLeft(null);
        clearInterval(timerId.current);
        didFinishCounting.current = true;
        loadTimeStamp.current = null;
      }
    }, 1000);
  }

  return { startTimer, timeLeft };
};
